import { motion } from "framer-motion";
import { FaCheckCircle } from "react-icons/fa";
import { usePageLeave, useWindowSize } from 'react-use';
import Confetti from 'react-confetti';
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { finishProccesThunk } from "../../store/slices/public/procesoMatriculacion.slice";
const CompletionChecklist = ({ ci_padre }) => {

    const dispatch = useDispatch();
    const { ci_estudiante } = useParams();
    const checklistItems = [
        "Contratos firmados",
        "Documentos enviados",
        "Formularios completados",
    ];

    const { width, height } = useWindowSize();

    const finishProcces = () => {
        const data = {
            matriculationEnd: true
        }
        dispatch(finishProccesThunk(ci_estudiante, ci_padre, data))
    }


    return (
        <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ type: "spring", stiffness: 260, damping: 20 }}
            className="p-6 bg-green-100 border border-green-400 text-green-700 rounded-lg shadow-lg text-center max-w-md mx-auto my-8"
        >
            <Confetti width={width} height={height} numberOfPieces={200} />
            <h2 className="text-2xl font-bold mb-4">¡Proceso completo! 🎉</h2>
            <ul className="space-y-3 text-left">
                {checklistItems.map((item, index) => (
                    <motion.li
                        key={index}
                        initial={{ x: -50, opacity: 0 }}
                        animate={{ x: 0, opacity: 1 }}
                        transition={{ delay: 0.2 * index }}
                        className="flex items-center space-x-3"
                    >
                        <FaCheckCircle className="text-green-500" />
                        <span>{item}</span>
                    </motion.li>
                ))}
            </ul>
            <div className="flex items-end w-full h-24 p-2 my-2 rounded-lg">
                <div className='flex items-center justify-start'>
                    <button onClick={finishProcces} className="flex items-center gap-2 bg-gradient-to-r from-cyan-500 to-blue-500 text-white px-4 py-2 rounded-xl shadow-md hover:from-cyan-600 hover:to-blue-600 transition-all duration-300 ease-in-out">
                        <svg className="w-5 h-5 animate-pulse" fill="none" stroke="currentColor" stroke-width="2"
                            viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <path stroke-linecap="round" stroke-linejoin="round"
                                d="M12 8c.379 0 .725.214.895.553l3.5 7A1 1 0 0115.5 17h-7a1 1 0 01-.895-1.447l3.5-7A1 1 0 0112 8z"></path>
                        </svg>
                        Finalizar proceso de matriculación
                    </button>
                </div>
            </div>
        </motion.div>
    );
};

export default CompletionChecklist;
